<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="កញ្ចប់ឥវ៉ាន់ទាំងអស់" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="New loan" name="second"></el-tab-pane> -->
			<!-- <el-tab-pane label="Loan calculator" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ លេខកូដ លេខទូរស័ព្ទ អ្នកផ្ញើរ ឬ អ្នកទទួល</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-70 md-size-20">
					<md-field>
						<label>ស្ថានភាព</label>
						<md-select placeholder="ស្ថានភាព (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="ndv">មិនមានអ្នកដឹក</md-option>
							<md-option value="wdv">កំពុងរង់ចាំអ្នកដឹក</md-option>
							<md-option value="dvr">កំពុងដឹកជញ្ជូន</md-option>
							<md-option value="dlv">បានដល់អតិថិជន</md-option>
							<md-option value="rtn">បានត្រឡប់</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-30 md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>
			<md-table v-if="packageList.length > 0">
				<md-table-row>
					<!-- <md-table-head>ល.រ</md-table-head> -->
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
					<md-table-head>អ្នកផ្ញើរ</md-table-head>
					<md-table-head>អ្នកទទួល</md-table-head>
					<md-table-head>អ្នកដឹកជញ្ជូន</md-table-head>
					<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
					<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(pkg, index) in packageList">
					<!-- <md-table-cell></md-table-cell> -->
					<md-table-cell>​{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
					</md-table-cell>
					<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
					<md-table-cell>{{pkg.sender_phone}} <br>({{pkg.client_name}})</md-table-cell>
					<md-table-cell>{{ pkg.receiver_phone }}</md-table-cell>
					<md-table-cell>
						<span v-if="pkg.status == 'ndv'">មិនមានអ្នកដឹក</span>
						<span v-else>{{ pkg.driver_phone }}<br>({{ pkg.driver_name }})</span>
					</md-table-cell>
					<md-table-cell><b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b><br><span
							v-if="pkg.price == 0">(ទូទាត់រួច)</span><span v-else>(មិនទាន់ទូទាត់)</span></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }}</b><br>
						({{config.getStatus(pkg.fee_responsible)}})</md-table-cell>
					<md-table-cell>
						<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
						<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
						<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
						<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
						<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/packages/detail/' + pkg.hash_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-info" @click="printLabel(pkg)">
							<md-icon>print</md-icon>
							<md-tooltip md-direction="top">ព្រីន</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-primary" @click="showIssueAction(pkg.id)">
							<md-icon>error</md-icon>
							<md-tooltip md-direction="top">កញ្ចប់មានបញ្ហា</md-tooltip>
						</md-button>
						<template v-if="$store.state.authentication.account_type == 'sa'">
							<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(pkg.id)">
								<md-icon>delete</md-icon>
								<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
							</md-button>
						</template>
					</md-table-cell>

				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="packageList.length == 0 && loadMore == true">មិនមានកញ្ចប់ឥវ៉ាន់</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>


		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបកញ្ចប់នេះពិតមែនទេ ?"
			md-content="ព័ត៌មានរបស់កញ្ចប់ឥវ៉ាន់នេះត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="onDelete" />
		<md-dialog-confirm :md-active.sync="issueDialogActive" md-title="តើអ្នកពិតជាចង់ដាក់បញ្ចូលកញ្ចប់នេះទៅក្នុងតារាងមានបញ្ហាឬ ?"
			md-content="" md-confirm-text="ដាក់បញ្ចូល"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="onIssue" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				issueDialogActive: false,
				issueSelected: '',
				search: {
					text: "",
					status: ""
				},
				loadMore: false,
				packageList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/package/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.packageList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.packageList = more ? this.packageList.concat(data.body.data) : data.body.data;
				})

			},

			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			addClient(client) {
				this.loan.client_id = client.id;
				this.loan.client.push(client);
				this.search.clientList = []
			},
			removeClient() {

				this.loan.client_id = "";
				this.loan.client = [];
			},
			printLabel(pkg) {
				let hash_id = pkg.hash_id;
				let tracking = pkg.tracking;
				let driver_phone = encodeURIComponent(pkg.driver_phone || "មិនមាន");
				let client_name = encodeURIComponent(pkg.client_name || "មិនមាន");
				let receiver_phone = encodeURIComponent(pkg.receiver_phone);
				let sender_phone = encodeURIComponent(pkg.sender_phone);
				let location = encodeURIComponent(pkg.location);
				let package_price = pkg.price == 0 ? "ទូទាត់រួច" : encodeURIComponent(this.config.moneylify(pkg.price, pkg.price_currency));
				let fee = pkg.fee_responsible == "snd" ? "ទូទាត់រួច" : encodeURIComponent(this.config.moneylify(pkg.fee, pkg.fee_currency));
				this.$http.get(`https://localhost:8084/print?hash_id=${hash_id}&tracking=${tracking}&sender_phone=${sender_phone}&receiver_phone=${receiver_phone}&driver_phone=${driver_phone}&package_price=${package_price}&delivery_fee=${fee}&location=${location}&sender_name=${client_name}`).then(data => {
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			showIssueAction(id) {
				this.issueSelected = id
				this.issueDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/package/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានលុបចេញពីបញ្ចីដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						// this.getEndLicense();
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onIssue() {
				this.$http.post(this.config.api + "/admin/package/issue", {
					id: this.issueSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានដាក់បញ្ចូលទៅកាន់តារាងមានបញ្ហាដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
				this.issueSelected = ""
				this.issueDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Packages/View.vue